var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products grid-products",class:[ _vm.products.length > 1 ? '' : 'onlyOne']},[_c('transition-group',{attrs:{"name":"fade"}},_vm._l((_vm.products),function(product,index){return _c('Product',{key:index,attrs:{"prod":product}})}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a68425c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = null
// module chunks = 